import { useSearchParams } from 'react-router'
import {
	PREVIEW_READONLY_PARAM,
	PREVIEW_READONLY_VALUE,
	TESTWEERGAVE_PATH,
} from '#app/utils/testweergave.ts'

/**
 * The testweergave banner: on top of a surface an operator stepped into
 * from Instellingen › Testweergaven. Says whose eyes these are, says
 * "alleen kijken" after a refused write (the `?testweergave=alleen-kijken`
 * bounce), and carries the one way out — a plain form post, so the
 * clearing cookie and the navigation happen in one document load.
 */
export function OyPreviewBanner({ name }: { name: string }) {
	const [searchParams] = useSearchParams()
	const readonly =
		searchParams.get(PREVIEW_READONLY_PARAM) === PREVIEW_READONLY_VALUE
	return (
		<div className="oy oy-preview" role="status">
			<span className="oy-preview-eye" aria-hidden="true">
				👁
			</span>
			<span className="oy-preview-text">
				<b>Testweergave</b>: je kijkt als {name}
				{readonly ? (
					<span className="oy-preview-note">
						{'. '}
						Alleen kijken, er wordt niets opgeslagen.
					</span>
				) : null}
			</span>
			<form method="post" action={TESTWEERGAVE_PATH}>
				<input type="hidden" name="intent" value="stop" />
				<button type="submit" className="oy-preview-exit">
					Terug naar Oyka
				</button>
			</form>
		</div>
	)
}
